import { Viewable } from '../protocols/viewable';
import { Subscribable } from './subscribable';
import { TemplateLayerTypeUtils } from '../../utils/template-layer-type-utils';
import { AfterViewInit, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RenderContextService } from '../../modules/services/render-context.service';

@Component({
  selector: 'app-render-context',
  template: '',
  standalone: false
})
export abstract class RenderContextComponent
  extends Subscribable
  implements OnInit, AfterViewInit, OnDestroy, Viewable
{
  constructor() {
    super();
    this.renderContext = inject(RenderContextService);
  }

  abstract setupViews();
  abstract setupBindings();

  protected renderContext: RenderContextService;

  public rendered = new BehaviorSubject<boolean>(false);
  Types = TemplateLayerTypeUtils;

  ngOnInit(): void {
    const renderContextId = this.renderContext.contextId;
    window.injector.isReadyService.signalWithInjectionContextCreated(this.rendered, renderContextId);
    this.setupViews();
  }

  ngAfterViewInit(): void {
    this.rendered.next(true);
    this.setupBindings();
  }

  ngOnDestroy() {
    const renderContextId = this.renderContext.contextId;
    window.injector.isReadyService.signalWithInjectionContextDestroyed(this.rendered, renderContextId);
    super.ngOnDestroy();
  }
}
